import { Spinner } from "react-bootstrap";

const SmallLoader = () => {
  return <Spinner size="sm" style={{ color: "#66C15E" }} />;
};
export default  SmallLoader;